import {
  SEARCH_FILES,
} from "./actionTypes"

const INIT_STATE = {
  files: [],
}

const files = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SEARCH_FILES:
      return {
        ...state,
        files: action.payload,
      }

    default:
      return state
  }
}

export default files
